/**
 * Mock de opciones previamente asignadas a productos del menú diario.
 * Sustituir por llamada real al backend cuando exista el endpoint.
 */
export const MOCK_PREVIOUS_DAILY_MENU_OPTIONS = [
	{
		id: 'mock-coca-cola',
		name: 'Coca-Cola',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Tamaño',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-coca-normal', name: 'Normal', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-coca-grande', name: 'Grande', enabled: 1, sortOrder: 1, priceSupplement: 0.5 },
				{ id: 'mock-coca-zero', name: 'Zero', enabled: 1, sortOrder: 2, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-coca-cola-zero',
		name: 'Coca-Cola Zero',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Tamaño',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-cocaz-normal', name: 'Normal', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-cocaz-grande', name: 'Grande', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-coca-cola-light',
		name: 'Coca-Cola Light',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Tamaño',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-cocal-normal', name: 'Normal', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-cocal-grande', name: 'Grande', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-fanta-naranja',
		name: 'Fanta Naranja',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Tamaño',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-fanta-n-normal', name: 'Normal', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-fanta-n-grande', name: 'Grande', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-fanta-limon',
		name: 'Fanta Limón',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Tamaño',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-fanta-l-normal', name: 'Normal', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-fanta-l-grande', name: 'Grande', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-sprite',
		name: 'Sprite',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Tamaño',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-sprite-normal', name: 'Normal', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-sprite-grande', name: 'Grande', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-aquarius',
		name: 'Aquarius',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Sabor',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-aquarius-naranja', name: 'Naranja', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-aquarius-limon', name: 'Limón', enabled: 1, sortOrder: 1, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-agua',
		name: 'Agua',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Formato',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-agua-vaso', name: 'Vaso', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-agua-botella', name: 'Botella 50cl', enabled: 1, sortOrder: 1, priceSupplement: 0.8 }
			]
		}
	},
	{
		id: 'mock-agua-con-gas',
		name: 'Agua con gas',
		priceSupplement: 0.5,
		nestedProductOptionType: {
			id: null,
			name: 'Formato',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-aguag-vaso', name: 'Vaso', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-aguag-botella', name: 'Botella', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-cerveza',
		name: 'Cerveza',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Tipo',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-cerveza-caña', name: 'Caña', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-cerveza-doble', name: 'Doble', enabled: 1, sortOrder: 1, priceSupplement: 1 },
				{ id: 'mock-cerveza-tercio', name: 'Tercio', enabled: 1, sortOrder: 2, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-cerveza-sin',
		name: 'Cerveza sin alcohol',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Formato',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-cervezasin-caña', name: 'Caña', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-cervezasin-tercio', name: 'Tercio', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-vino-tinto',
		name: 'Vino tinto',
		priceSupplement: 1,
		nestedProductOptionType: {
			id: null,
			name: 'Medida',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-vtinto-copa', name: 'Copa', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-vtinto-botella', name: 'Botella', enabled: 1, sortOrder: 1, priceSupplement: 8 }
			]
		}
	},
	{
		id: 'mock-vino-blanco',
		name: 'Vino blanco',
		priceSupplement: 1,
		nestedProductOptionType: {
			id: null,
			name: 'Medida',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-vblanco-copa', name: 'Copa', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-vblanco-botella', name: 'Botella', enabled: 1, sortOrder: 1, priceSupplement: 8 }
			]
		}
	},
	{
		id: 'mock-cafe',
		name: 'Café',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Preparación',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-cafe-solo', name: 'Solo', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-cafe-cortado', name: 'Cortado', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-cafe-con-leche', name: 'Con leche', enabled: 1, sortOrder: 2, priceSupplement: 0.3 }
			]
		}
	},
	{
		id: 'mock-te',
		name: 'Té',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Variedad',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-te-negro', name: 'Negro', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-te-verde', name: 'Verde', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-te-manzanilla', name: 'Manzanilla', enabled: 1, sortOrder: 2, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-zumo-naranja',
		name: 'Zumo de naranja',
		priceSupplement: 0.5,
		nestedProductOptionType: {
			id: null,
			name: 'Tipo',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-zumo-natural', name: 'Natural', enabled: 1, sortOrder: 0, priceSupplement: 0.5 },
				{ id: 'mock-zumo-botella', name: 'De botella', enabled: 1, sortOrder: 1, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-ensalada-mixta',
		name: 'Ensalada mixta',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Extras',
			type: 1,
			min: 0,
			max: 3,
			options: [
				{ id: 'mock-ensalada-atun', name: 'Atún', enabled: 1, sortOrder: 0, priceSupplement: 1.5 },
				{ id: 'mock-ensalada-queso', name: 'Queso', enabled: 1, sortOrder: 1, priceSupplement: 1 },
				{ id: 'mock-ensalada-huevo', name: 'Huevo', enabled: 1, sortOrder: 2, priceSupplement: 0.8 }
			]
		}
	},
	{
		id: 'mock-paella',
		name: 'Paella',
		priceSupplement: 2,
		nestedProductOptionType: {
			id: null,
			name: 'Tipo',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-paella-valenciana', name: 'Valenciana', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-paella-marisco', name: 'Marisco', enabled: 1, sortOrder: 1, priceSupplement: 3 },
				{ id: 'mock-paella-mixta', name: 'Mixta', enabled: 1, sortOrder: 2, priceSupplement: 2 }
			]
		}
	},
	{
		id: 'mock-tortilla',
		name: 'Tortilla española',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Punto',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-tortilla-jugosa', name: 'Jugosa', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-tortilla-cuajada', name: 'Cuajada', enabled: 1, sortOrder: 1, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-croquetas',
		name: 'Croquetas',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Sabor',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-croquetas-jamon', name: 'Jamón', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-croquetas-pollo', name: 'Pollo', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-croquetas-bacalao', name: 'Bacalao', enabled: 1, sortOrder: 2, priceSupplement: 0.5 },
				{ id: 'mock-croquetas-setas', name: 'Setas', enabled: 1, sortOrder: 3, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-hamburguesa',
		name: 'Hamburguesa',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Punto de carne',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-burger-poco', name: 'Poco hecha', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-burger-al-punto', name: 'Al punto', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-burger-muy', name: 'Muy hecha', enabled: 1, sortOrder: 2, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-pizza',
		name: 'Pizza',
		priceSupplement: 1,
		nestedProductOptionType: {
			id: null,
			name: 'Tamaño',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-pizza-mediana', name: 'Mediana', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-pizza-familiar', name: 'Familiar', enabled: 1, sortOrder: 1, priceSupplement: 4 }
			]
		}
	},
	{
		id: 'mock-pasta',
		name: 'Pasta',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Salsa',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-pasta-bolo', name: 'Boloñesa', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-pasta-carbonara', name: 'Carbonara', enabled: 1, sortOrder: 1, priceSupplement: 1 },
				{ id: 'mock-pasta-pesto', name: 'Pesto', enabled: 1, sortOrder: 2, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-postre-tarta',
		name: 'Tarta de queso',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Extra',
			type: 1,
			min: 0,
			max: 1,
			options: [
				{ id: 'mock-tarta-sin', name: 'Sin extra', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-tarta-fruta', name: 'Con frutos rojos', enabled: 1, sortOrder: 1, priceSupplement: 0.8 }
			]
		}
	},
	{
		id: 'mock-helado',
		name: 'Helado',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Sabor',
			type: 1,
			min: 1,
			max: 2,
			options: [
				{ id: 'mock-helado-vainilla', name: 'Vainilla', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-helado-chocolate', name: 'Chocolate', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-helado-fresa', name: 'Fresa', enabled: 1, sortOrder: 2, priceSupplement: null },
				{ id: 'mock-helado-limon', name: 'Limón', enabled: 1, sortOrder: 3, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-gazpacho',
		name: 'Gazpacho',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Acompañamiento',
			type: 1,
			min: 0,
			max: 2,
			options: [
				{ id: 'mock-gazpacho-picatostes', name: 'Picatostes', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-gazpacho-huevo', name: 'Huevo duro', enabled: 1, sortOrder: 1, priceSupplement: 0.5 }
			]
		}
	},
	{
		id: 'mock-salmon',
		name: 'Salmón a la plancha',
		priceSupplement: 3,
		nestedProductOptionType: {
			id: null,
			name: 'Guarnición',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-salmon-patatas', name: 'Patatas', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-salmon-arroz', name: 'Arroz', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-salmon-verduras', name: 'Verduras', enabled: 1, sortOrder: 2, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-entrecot',
		name: 'Entrecot',
		priceSupplement: 5,
		nestedProductOptionType: {
			id: null,
			name: 'Punto',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-entrecot-poco', name: 'Poco hecho', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-entrecot-al-punto', name: 'Al punto', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-entrecot-muy', name: 'Muy hecho', enabled: 1, sortOrder: 2, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-bocadillo',
		name: 'Bocadillo',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Relleno',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-boca-jamon', name: 'Jamón', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-boca-lomo', name: 'Lomo', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-boca-tortilla', name: 'Tortilla', enabled: 1, sortOrder: 2, priceSupplement: null },
				{ id: 'mock-boca-atun', name: 'Atún', enabled: 1, sortOrder: 3, priceSupplement: null }
			]
		}
	},
	{
		id: 'mock-menu-infantil',
		name: 'Menú infantil',
		priceSupplement: 0,
		nestedProductOptionType: {
			id: null,
			name: 'Plato principal',
			type: 1,
			min: 1,
			max: 1,
			options: [
				{ id: 'mock-infantil-nuggets', name: 'Nuggets', enabled: 1, sortOrder: 0, priceSupplement: null },
				{ id: 'mock-infantil-hamburguesa', name: 'Mini hamburguesa', enabled: 1, sortOrder: 1, priceSupplement: null },
				{ id: 'mock-infantil-pasta', name: 'Pasta', enabled: 1, sortOrder: 2, priceSupplement: null }
			]
		}
	}
]

function normalizeText(text) {
	return String(text || '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim()
}

/**
 * Busca productos con opciones previamente asignadas cuyo nombre coincida con la query.
 * @param {string} query
 * @returns {typeof MOCK_PREVIOUS_DAILY_MENU_OPTIONS}
 */
export function searchMockPreviousDailyMenuOptions(query) {
	const normalizedQuery = normalizeText(query)
	if (normalizedQuery.length < 1) return []

	// Para probar listas largas: "todos" / "all" / "*" devuelve el catálogo completo
	if (['todos', 'all', '*'].includes(normalizedQuery)) {
		return MOCK_PREVIOUS_DAILY_MENU_OPTIONS
	}

	return MOCK_PREVIOUS_DAILY_MENU_OPTIONS.filter((item) =>
		normalizeText(item.name).includes(normalizedQuery)
	)
}
